import { useAppDispatch } from 'src/app/store/hooks';
import { useLazyAssignmentsRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';
import { assignmentManagementSlice } from 'src/features/team/assignment-management/assignmentManagement.slice';

import { MenuItem } from './AssignmentHeaderMenu';

export function EditAssignmentMenuItem({
  assignmentId,
}: {
  assignmentId: string;
}) {
  const dispatch = useAppDispatch();
  const [fetchAssignement] = useLazyAssignmentsRetrieveQuery();
  return (
    <MenuItem
      label="Edit crew schedule"
      onClick={async () => {
        const assignment = await fetchAssignement({
          id: assignmentId,
        }).unwrap();
        dispatch(
          assignmentManagementSlice.actions.setSelectedAssignment(assignment)
        );
        dispatch(
          assignmentManagementSlice.actions.setShowAssignmentManagementModal(
            true
          )
        );
      }}
    />
  );
}
